import { StateCreator } from 'zustand';
import { IHeaderFooter } from './headerFooter.interface';

export const headerFooterSlice: StateCreator<IHeaderFooter> = (set) => ({
  headerFooter: {},
  setHeaderFooter(data: Record<string, any>) {
    set(() => ({ headerFooter: data }));
  },
});
